import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { ScheduledReportService } from "@services/scheduledReport.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "scheduledReports",
	styleUrls: ["scheduledReports.css"],
	templateUrl: "scheduledReports.html"
})
export class ScheduledReportsAdminComponent {
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	isSuperAdmin = false;
	itemType = "Scheduled Report"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4] + "/" + location.href.split("/")[5];
	items: any[] = [];
	people: UserProfile[] = [];
	title: string;
	userProfileId: number;
	
	constructor(private appSettingsService: AppSettingsService, private router: Router, private itemService: ScheduledReportService, private toastService: ToastService, private userProfileService: UserProfileService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.title = `${this.itemType}s`;
		this.gridLoading = true;
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");
		this.userProfileId = this.appSettingsService.get("profileId");
		this.getItems();
		this.getPeople();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if (result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		if (this.isSuperAdmin) {
			this.itemService.getAll()
				.subscribe(
					(res: any) => { this.items = res.response.items;
						this.gridLoading = false;
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
		else
		{
			this.itemService.forUserProfile(this.userProfileId)
				.subscribe(
					(res: any) => { this.items = res.response.items;
						this.gridLoading = false;
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}
	
	getPeople() {
		this.userProfileService.getAllWithUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err: any) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}